//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    },

    methods: {
        pauseGame () {
            axios.post('game/pause').then(response => {
                this.$store.commit('storeGameData', response.data.data);
                this.$router.push({ name: 'cockpit' });
            }).catch(() => {});
        }
    }
};
